module.exports = __webpack_public_path__ + "static/media/leststart.23bb6593.png";